import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import { FETCH_INTERVENTION_SUCCESS, UPDATE_KIOSK_PREFERENCES, UPDATE_KIOSK_PREFERENCES_SUCCESS } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: boolean,
 *   data: import("modules/interventions/types/projections/kanban-intervention").KioskPreference,
 * }} KioskPreferenceState
 */

/** @type {KioskPreferenceState} */
const initialState = { loading: false, data: null };

const updateKioskPreference = (_, { payload: intervention }) => intervention.kioskPreference ?? null;

export default combineReducers({
  loading: loadingReducer(UPDATE_KIOSK_PREFERENCES),
  data: createReducer(initialState, {}, [
    {
      matcher: ({ type, meta }) => type === FETCH_INTERVENTION_SUCCESS && meta.source === 'intervention-details',
      reducer: updateKioskPreference,
    },
    {
      matcher: ({ type, meta }) => type === UPDATE_KIOSK_PREFERENCES_SUCCESS && meta.source === 'intervention-details',
      reducer: updateKioskPreference,
    },
  ]),
});
